import root from "window-or-global";
import {getLangCode} from "./getLangCode";

export function getLanguages() {
    return root.marketConfig.availableLocales.map((locale) => ({
        locale,
        lang: getLangCode(locale),
    }));
}
